<div class="input-group mb-3" fxFlex>
  <input type="search" class="form-control" aria-label="Text input with dropdown button" [(ngModel)]="selectedCustomerName" placeholder="{{ 'CUSTOMER.SELECTOR.SEARCH' | translate }}" readonly />
  @if (isClearable) {
    <div fxFlex="20px" style="padding-top: 5px;"><button (click)="resetCustomerInternal()" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button></div>
  }
  
        <button class="btn btn-primary" type="button" (click)="customerPickup()">
            <i class="fas fa-search pe-0"></i>
        </button>
      <button class="btn-border-right btn btn-secondary" type="button" (click)="customerPickupBarcode()">
        <i class="fas fa-barcode pe-0"></i>
      </button>
    
</div>
